import React, { useState, useEffect, useRef } from "react";
import { injectIntl } from "react-intl";
import "./style.scss";
import {tasksImage} from "../../utils/images";
import CancelIcon from '@material-ui/icons/Cancel';
import * as actions from "../../store/Tasks/actions";
import { useDispatch } from "react-redux";
import moment from "moment";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import DateFnsUtils from '@date-io/date-fns';
import { useLocation } from "react-router-dom";
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

const TaskForm = ({ intl: { messages }, show, close, reloadData, task, view }) => {
     const lang = localStorage.getItem("lang") || "en";
     const location = useLocation();
     const dispatch = useDispatch();
     const feedbackRef = useRef(null);
     // const dateRef = useRef(null);
     const reasonRef = useRef(null);
     const detailsRef = useRef(null);
     const [feedBack, setFeedBack] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const [finishConfirmation, setFinishConfirmation] = useState(false);
     const [isLate, setIsLate] = useState(false);
     const [selectedDate, setSelectedDate] = useState(new Date(moment().format("YYYY-MM-DDTHH:mm")));
    
     // Task Data
     const [taskData, setTaskData] = useState({
        id: Math.random(100),
        complete_date: moment(),
        due_date: moment(),
        description: "",
        status_id: 1,
        reason: "",
        history: [{
            status_id: 1,
        }],
        location: location.pathname,
     });
     // Clear Task Data Function
     const clear = () => {
        setSelectedDate(new Date(moment().format("YYYY-MM-DDTHH:mm")))
        setTaskData({
            id: Math.random(100),
            complete_date: new Date(moment().format("YYYY-MM-DDTHH:mm")),
            due_date: new Date(moment().format("YYYY-MM-DDTHH:mm")),
            description: "",
            status_id: 1,
            reason: "",
            history: [{
                status_id: 1
            }],
            location: location.pathname,
        });
    }

    // Clear Form and feedback
    useEffect(() => {
        if (show) {
            setFeedBack(null);
            // dateRef.current.style.borderColor = '#eee';
            detailsRef.current.style.borderColor = '#eee';
            feedbackRef.current.style.color = '#080';
            if (reasonRef.current) {
                reasonRef.current.style.borderColor = '#eee';
            }
            if (!task) {
                clear();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);


     // Check for late task - LOG VIEW
     useEffect(() => {
         if (task) {
            setTaskData({
                ...task,
            });
            let findItems = 0;
            task.history.forEach((item) => {
                if (item.status_id === 3) {
                    findItems++;
                }
            });
            if (findItems > 0) {
                setIsLate(true);
            } else {
                setIsLate(false);
            }
            setSelectedDate(task.complete_date);
         }
     }, [task])

     // Check for Date selection
     useEffect(() => {
        if (selectedDate) {
            setFeedBack(null)
            //dateRef.current.style.borderColor = '#eee';
            setTaskData({ 
                ...taskData, 
                complete_date: moment(selectedDate).format("YYYY-MM-DD HH:mm:ss")
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate])

    // Finish Task
    const finishTask = () => {
        dispatch(actions.finishTaskRequest(taskData));
        setFeedBack(messages.tasks.form.success_finish);
        setTimeout(function(){
             setFeedBack(null);
            close();
       }, 0);
    }
    
     const handleSave = (e) => {
        e?.preventDefault();

        // Validation 
        if (moment(taskData.complete_date).isBefore(moment().subtract(1, 'minutes'))) {
            //dateRef.current?.focus();
            //dateRef.current.style.borderColor = 'rgba(148, 83, 74, 0.877)';
            feedbackRef.current.style.color = 'rgba(148, 83, 74, 0.877)';
            setFeedBack(messages.tasks.form.date_error);
            return;
        }            
        if (taskData.description?.length === 0) {
            detailsRef.current?.focus();
            detailsRef.current.style.borderColor = 'rgba(148, 83, 74, 0.877)';
            feedbackRef.current.style.color = 'rgba(148, 83, 74, 0.877)';
            setFeedBack(messages.tasks.form.details_error);
            return;
        }
        if ((task?.status_id === 2 && reasonRef.current.value.length === 0) || (task?.status_id === 3 && reasonRef.current.value.length === 0)) {
            reasonRef.current?.focus();
            reasonRef.current.style.borderColor = 'rgba(148, 83, 74, 0.877)';
            feedbackRef.current.style.color = 'rgba(148, 83, 74, 0.877)';
            setFeedBack(messages.tasks.form.reason_error);
            return;
        }
        //dateRef.current.style.borderColor = '#eee';
        detailsRef.current.style.borderColor = '#eee';
        feedbackRef.current.style.color = '#080';
        if (reasonRef.current) {
            reasonRef.current.style.borderColor = '#eee';
        }  
                
        setFeedBack(null);
        // If task is not null, update it
        if (task) {
            // Edit
            dispatch(actions.editTaskRequest(taskData));
            setFeedBack(messages.tasks.form.success_edit);
            setTimeout(function(){
                setFeedBack(null);
                //reloadData();
                close(); 
            }, 0);

        } else {
            // Create
            dispatch(actions.addTaskRequest(taskData));
            setFeedBack(messages.tasks.form.success);
            clear();
            setTimeout(function(){
                setFeedBack(null);
                close();
                //reloadData();
            }, 0);
        }
    };

     // Close Modal
     const handleClose = (e) => {
        e.preventDefault();
        setFeedBack(null);
        if (task && task.complete_date === taskData.complete_date && task.description === taskData.description) {
            close();
            return;
        }
        if (taskData.description.length > 0 || moment(taskData.complete_date).isAfter(moment())) {
            setShowConfirmation(true);
        } else {
            close();
        }
    };

    return (
        <div className={`form-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="form-modal_container_content">
                    <CancelIcon onClick={handleClose} className="form-modal_container_content_close" />
                <div className="form-modal_container_content_header">
                    <img src={tasksImage} alt="Tasks" />
                    <h4>{view ? messages.tasks.form.view_title : task ? messages.tasks.form.edit_title : messages.tasks.form.add_title}</h4>
                </div>
                <div className="form-modal_container_content_body">
                <form>
                    <div className="form-modal_container_content_body_group">
                        <label>{messages.tasks.form.date}</label>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker  disabled={task?.status_id === 4 || task?.status_id === 5}
                                //ref={dateRef}
                                className="datetime-picker"
                                // type="datetime-local" 
                                // placeholder={messages.tasks.form.date_placeholder}
                                format="yyyy/MM/dd hh:mm a"
                                value={selectedDate} 
                                onChange={setSelectedDate} />
                        </MuiPickersUtilsProvider>
                    </div>
                    {
                       (task?.status_id === 2) || (task?.status_id === 3) ? (
                            <div className="form-modal_container_content_body_group">
                                <label className={task?.status_id === 2 || task?.status_id === 3 ? 'required' : ''}>{messages.tasks.form.editing_reason}</label>
                                <input  disabled={task?.status_id === 4 || task?.status_id === 5}
                                        ref={reasonRef} 
                                        type="text" 
                                        placeholder={messages.tasks.form.reason_placeholder}
                                        value={taskData.reason}
                                        onChange={(e) => {
                                            setFeedBack(null)
                                            //dateRef.current.style.borderColor = '#eee';
                                            setTaskData({ 
                                                ...taskData, 
                                                reason: e.target.value
                                        })}} />
                            </div>
                        ) : null
                    }
                    <div className="form-modal_container_content_body_group">
                        <label>{messages.tasks.form.details}</label>
                        <textarea   disabled={task?.status_id === 4 || task?.status_id === 5}
                                    ref={detailsRef} 
                                    placeholder={messages.tasks.form.details_placeholder} 
                                    rows={3}
                                    value={taskData.description} 
                                    onChange={(e) => {
                                        setFeedBack(null)
                                        //dateRef.current.style.borderColor = '#eee';
                                        setTaskData({ 
                                            ...taskData, 
                                            description: e.target.value 
                                        })}} />
                    </div>
                    {
                        task && (
                            <div className="form-modal_container_content_body_flexgroup">
                                <label>{messages.tasks.form.assignedBy} :</label>
                                <strong style={{margin: '0 5px'}}>{task.created_by}</strong>
                                <span>({task.creatable_role})</span>
                            </div>
                        )
                    }
                    {
                        task && (
                            <div className="form-modal_container_content_body_log"
                                style={task.history?.length > 4 ? {overflowX: 'scroll'} : null}>
                                <div className="form-modal_container_content_body_log_item" style={isLate ? {flex: '0 0 20%'} : {flex: `0 0 ${80/3}%`}}>
                                    <label>{messages.tasks.form.log.creation_date}</label>
                                    <label>
                                            {moment(task?.created_at).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}
                                    </label>
                                </div>
                                <span className="dots" style={isLate ? {flex: `0 0 ${20/3}%`} : {flex: '0 0 10%'}}>........</span>
                                <div className="form-modal_container_content_body_log_item" style={isLate ? {flex: '0 0 20%'} : {flex: `0 0 ${80/3}%`}}>
                                    <label>{messages.tasks.form.log.in_progress}</label>
                                    <label>
                                        {
                                            task.history.map((item, index) => (
                                                item.status_id === 2 && (
                                                    <span key={index}>
                                                        {moment(task?.history[index]?.date).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}
                                                    </span>
                                                )
                                            ))
                                        }
                                    </label>
                                </div>
                                <span className="dots" style={isLate ? {flex: `0 0 ${20/3}%`} : {flex: '0 0 10%'}}>........</span>
                                {
                                    task.history.map((item, index) => (
                                        item.status_id === 3 && (
                                            <div key={index} 
                                                className="form-modal_container_content_body_log_item" 
                                                style={isLate ? {flex: '0 0 20%'} : {flex: `0 0 ${80/3}%`}}>
                                                <label>{messages.tasks.form.log.in_progress_late}</label>
                                                <label>
                                                    <span>
                                                        {moment(task?.history[index]?.date).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}
                                                    </span>
                                                </label>
                                            </div>
                                        )
                                    ))
                                }
                                <span className="dots" style={isLate ? {flex: `0 0 ${20/3}%`} : {flex: '0 0 0'}}>........</span>
                                <div className="form-modal_container_content_body_log_item" style={isLate ? {flex: '0 0 20%'} : {flex: `0 0 ${80/3}%`}}>
                                    <label>{messages.tasks.form.log.completed}</label>
                                    <label>
                                        {
                                            task.history.map((item, index) => (
                                                item.status_id === 4 || item.status_id === 5 ? (
                                                    <span key={index}>
                                                        {moment(task?.complete_date).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}
                                                    </span>
                                                ) : null
                                            ))
                                        }
                                    </label>
                                </div>
                            </div>
                        )
                    }
                    <div className="form-modal_container_content_body_actions">
                            <button className="cancel_btn" 
                                onClick={(e) => {
                                if (view && task?.status_id !== 4 && task?.status_id !== 5) {
                                    e.preventDefault();
                                    setFinishConfirmation(true)
                                } else { handleClose(e) }
                                 }}>
                                    {
                                        view && task?.status_id !== 4 && task?.status_id !== 5 
                                        ? messages.tasks.form.finish 
                                        : messages.tasks.form.cancel
                                    }
                            </button>
                            {  !task || (task && task?.status_id !== 4 && task?.status_id !== 5) ? 
                                    <button onClick={(e) =>  handleSave(e) } >
                                        {task ? messages.tasks.form.edit : messages.tasks.form.save}
                                    </button>
                                : null
                            }
                    </div>
                    <p ref={feedbackRef} id="feedback"><span style={{ background: '#FFF' }}>{feedBack}</span></p>
                </form>
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
            <ConfirmDialog show={finishConfirmation} 
                     onCancel={() => setFinishConfirmation(false)}
                     onConfirm={() => {
                        setFinishConfirmation(false);
                        finishTask();
                     }}
                     icon={null}
                     content={messages.warningMsgs.warning_finish}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
};

export default injectIntl(TaskForm);
